import { appUrl } from "@/constants";
import { BrandColors } from "@/constants/theme";
import React, { useCallback } from 'react';
import { ActivityIndicator, Linking, Platform, StyleSheet, View } from 'react-native';
import { WebView, WebViewNavigation } from 'react-native-webview';
import { SafeAreaView } from "react-native-safe-area-context";
import { router, useFocusEffect } from "expo-router";

const isWeb = Platform.OS === "web";

const StripeConnectWebView = ({ connectUrl, onComplete, onCancel }: { connectUrl: string, onComplete: () => void, onCancel: () => void }) => {

  useFocusEffect(
    useCallback(() => {
      if (isWeb) {
        Linking.openURL(connectUrl);
        router.back();
      }
    }, [connectUrl]),
  );
  
  const handleNavigationStateChange = (syntheticEvent: WebViewNavigation) => {
    const url  = syntheticEvent.url;
    
    // Check the URL for your defined return or refresh URLs
    if (url.startsWith(appUrl)) {
      // Extract necessary information (e.g., authorization code, status) from the URL
      // and call the appropriate callback function
      if (url.includes('return')) {
        onComplete();
      } else if (url.includes('refresh')) {
        onCancel();
      }
    }
  };

  return (
    <SafeAreaView style={styles.container}>
      <WebView
        source={{ uri: connectUrl }}
        onNavigationStateChange={handleNavigationStateChange}
        javaScriptEnabled={true}
        domStorageEnabled={true}
        mixedContentMode="always"
        renderLoading={() => (
            <View style={styles.loadingIndicator}>
                <ActivityIndicator size="large" color={BrandColors.primary} />
            </View>
        )}
      />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  loadingIndicator: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    zIndex: 1,
  },
});

export default StripeConnectWebView;
